import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAppSelector } from './app/hooks';
import { IGlobal } from './config/config.interface';
import { redirectToParticipantExperience, shouldRedirectToParticipantExperience } from 'lib/helpers/pe-redirect';


function App() {
  const user = useAppSelector((state) => state.user);
  const globalConfig = (global as any as IGlobal);
  const navigate = useNavigate();

  useEffect(() => {
    // Do our base routing here
    if (shouldRedirectToParticipantExperience(user.type, user.redirect?.pqp)) {
      if (redirectToParticipantExperience()) {
        return;
      }
      navigate('/assessments');
    } else if (user.type === globalConfig.config.USER_TYPE_PARTICIPANT || user.redirect?.pqp !== 0) {
      navigate('/assessments');
    } else {
      // navigate('/manage');
      setTimeout(() => {
        window.location.href = globalConfig.config.URL_CERTIFIED_USER_LEGACY + "/Default.aspx?_auth=" + user.id;
      }, 100);
    }
  }, [user, navigate])



  // let element = useRoutes(routes);

  return (
    <>
    </>
  )

}

export default App;
